import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaLinkedinIn,
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";


const ContactForm = () => {
  const COLORS = {
    bg: "#0A0A0A",
    card: "rgba(255,255,255,0.04)",
    border: "rgba(255,255,255,0.08)",
    gold: "#D4AF37",
    text: "#EDEDED",
    sub: "#A0A0A0",
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;

    const whatsappMessage = `Name: ${name}%0AEmail: ${email}%0ASubject: ${subject}%0AMessage: ${message}`;
    window.open(`https://wa.me/918650337072?text=${whatsappMessage}`);
  };

  return (
    <section style={{ background: COLORS.bg }} className="py-20 px-6">
      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="mb-14">
          <p className="uppercase tracking-[0.4em] text-sm mb-3" style={{ color: COLORS.gold }}>
            Contact Us
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white">
            Get Legal <span className="text-white/50">Assistance</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-10">

          {/* LEFT */}
          <div className="space-y-6">

            <div className="p-8 rounded-2xl backdrop-blur-xl" style={{ background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
              <FaMapMarkerAlt style={{ color: COLORS.gold }} />
              <h3 className="text-white text-lg font-semibold mt-3">Office Address</h3>
              <p style={{ color: COLORS.sub }} className="text-sm mt-1">
                Adv Akash Giri, Chamber no-F-224, Karkardooma Rd, Arjun Gali, Vishwas Nagar, Shahdara, New Delhi, Delhi, 110092
              </p>
            </div>
            <div className="p-8 rounded-2xl backdrop-blur-xl" style={{ background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
              <MdEmail style={{ color: COLORS.gold }} />
              <h3 className="text-white text-lg font-semibold mt-3">Email Id</h3>
              <p style={{ color: COLORS.sub }} className="text-sm mt-1">
                akashgiri000@gmail.com
              </p>
            </div>

            <div className="p-8 rounded-2xl backdrop-blur-xl" style={{ background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
              <FaPhoneAlt style={{ color: COLORS.gold }} />
              <h3 className="text-white text-lg font-semibold mt-3">Call Us</h3>
              <p className="text-white font-bold mt-1">+91 86503 37072</p>
            </div>

            <a
              href="https://wa.me/918650337072"
              className="flex items-center gap-3 p-6 rounded-2xl"
              style={{ background: COLORS.gold, color: "black" }}
            >
              <FaWhatsapp /> Chat on WhatsApp
            </a>

            <div className="flex gap-4 pt-4">
              {[
                { icon: FaFacebookF, link: "https://www.facebook.com/advakashgiri" },
                // { icon: FaLinkedinIn, link: "https://linkedin.com" },
                { icon: FaInstagram, link: "https://www.instagram.com/p/DWOYXHLCf_G/" },
                // { icon: FaYoutube, link: "https://youtube.com" },
              ].map((item, i) => {
                const Icon = item.icon;
                return (
                  <a
                    key={i}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center rounded-xl hover:scale-110 transition"
                    style={{ background: COLORS.card, border: `1px solid ${COLORS.border}` }}
                  >
                    <Icon style={{ color: "white" }} size={16} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* RIGHT */}
          <form onSubmit={handleSubmit}
            className="p-10 rounded-2xl backdrop-blur-xl space-y-6"
            style={{ background: COLORS.card, border: `1px solid ${COLORS.border}` }}
          >
            <h3 className="text-2xl text-white font-bold">Send Message</h3>

            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-4 rounded-xl bg-black/40 text-white border border-white/10"
            />

            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-4 rounded-xl bg-black/40 text-white border border-white/10"
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              className="w-full p-4 rounded-xl bg-black/40 text-white border border-white/10"
            />

            <textarea
              name="message"
              placeholder="Your Message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              className="w-full p-4 rounded-xl bg-black/40 text-white border border-white/10"
            />

            <button
              type="submit"
              className="w-full py-4 rounded-xl font-bold"
              style={{ background: COLORS.gold, color: "black" }}
            >
              Submit Request
            </button>
          </form>

        </div>
      </div>
    </section>
  );
};

export default ContactForm;
